export const RESET_STORE = 'RESET_STORE'

// AUTH ACTION TYPES
export const FETCH_USER = 'FETCH_USER'
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT = 'LOGOUT'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'
export const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE'
export const CLEAR_MESSAGE_ERROR = 'CLEAR_MESSAGE_ERROR'

// USER ACTION TYPES
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'
export const UPDATE_PROMPT_REQUEST = 'UPDATE_PROMPT_REQUEST'
export const UPDATE_PROMPT_SUCCESS = 'UPDATE_PROMPT_SUCCESS'
export const UPDATE_PROMPT_FAILURE = 'UPDATE_PROMPT_FAILURE'
export const FETCH_PROMPTS_REQUEST = 'FETCH_PROMPTS_REQUEST'
export const FETCH_PROMPTS_SUCCESS = 'FETCH_PROMPTS_SUCCESS'
export const FETCH_PROMPTS_FAILURE = 'FETCH_PROMPTS_FAILURE'
export const SET_IS_BOARDED = 'SET_IS_BOARDED'

// DOCUMENT
export const SET_LOADING_DOCUMENT = 'SET_LOADING_DOCUMENT'
export const SET_DOCUMENT = 'SET_DOCUMENT'
export const SET_IS_MODAL_MOBILE_VISIBLE = 'SET_IS_MODAL_MOBILE_VISIBLE'
export const CLEAR_DOCUMENT = 'CLEAR_DOCUMENT'
export const SET_SELECTED_CITATION = 'SET_SELECTED_CITATION'
export const SET_TRANSLATION_PROGRESS = 'SET_TRANSLATION_PROGRESS'
export const SET_TRANSLATION_IN_PROGRESS = 'SET_TRANSLATION_IN_PROGRESS'
export const SET_DOCUMENT_SOURCE_URL = 'SET_DOCUMENT_SOURCE_URL'

// SEARCH
export const SEARCH_REQUEST = 'SEARCH_REQUEST'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAILURE = 'SEARCH_FAILURE'
export const FETCH_RECENT_SEARCHES = 'FETCH_RECENT_SEARCHES'
export const FETCH_AUTOCOMPLETE_RESULTS = 'FETCH_AUTOCOMPLETE_RESULTS'
export const RESET_SEARCH_STORE = 'RESET_SEARCH_STORE'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'

export const RESET_AVAILABLE_DOC_TYPES = 'RESET_AVAILABLE_DOC_TYPES'
export const SET_SEARCH_SELECTED_CITATION = 'SET_SEARCH_SELECTED_CITATION'
export const SET_SEARCH_DOCUMENT_SOURCE_URL = 'SET_SEARCH_DOCUMENT_SOURCE_URL'
export const SET_SEARCH_LOADING_DOCUMENT = 'SET_SEARCH_LOADING_DOCUMENT'
export const SET_SEARCH_DOCUMENT = 'SET_SEARCH_DOCUMENT'
export const SET_SEARCH_IS_MODAL_MOBILE_VISIBLE =
  'SET_SEARCH_IS_MODAL_MOBILE_VISIBLE'
export const SEARCH_CLEAR_DOCUMENT = 'SEARCH_CLEAR_DOCUMENT'
export const SET_SELECTED_DOC_TYPES = 'SET_SELECTED_DOC_TYPES'
export const SET_AVAILABLE_DOC_TYPES = 'SET_AVAILABLE_DOC_TYPES'
export const SET_FILTERED_CITATIONS = 'SET_FILTERED_CITATIONS'
export const SET_IS_LOADING_SEARCH_CITATIONS = 'SET_IS_LOADING_SEARCH_CITATIONS'
export const SET_IS_LOADING_AUTO_COMPLETE_SEARCH = 'SET_IS_LOADING_AUTO_COMPLETE_SEARCH'
export const UPDATE_FROM_AUTO_SELECT = 'UPDATE_FROM_AUTO_SELECT'
export const CANCEL_SEARCH = 'CANCEL_SEARCH'
export const SET_IS_ABROGE_FILTER = 'SET_IS_ABROGE_FILTER'
export const SET_DATE_FILTER = 'SET_DATE_FILTER'
export const CLEAR_DATE_FILTER = 'CLEAR_DATE_FILTER'
export const SET_DATE_SORT = 'SET_DATE_SORT'
export const CLEAR_DATE_SORT = 'CLEAR_DATE_SORT'

// Filtered Search (server-side)
export const FILTERED_SEARCH_REQUEST = 'FILTERED_SEARCH_REQUEST'
export const FILTERED_SEARCH_SUCCESS = 'FILTERED_SEARCH_SUCCESS'
export const FILTERED_SEARCH_FAILURE = 'FILTERED_SEARCH_FAILURE'
export const PAGINATE_SEARCH_SUCCESS = 'PAGINATE_SEARCH_SUCCESS'
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS'
export const CLEAR_SEARCH_FILTERS = 'CLEAR_SEARCH_FILTERS'
export const SET_SEARCH_FACETS = 'SET_SEARCH_FACETS'
export const SET_FILTER_PANEL_OPEN = 'SET_FILTER_PANEL_OPEN'

// Pre-Search Filters
export const SET_PRE_SEARCH_FILTERS = 'SET_PRE_SEARCH_FILTERS'
export const CLEAR_PRE_SEARCH_FILTERS = 'CLEAR_PRE_SEARCH_FILTERS'
export const SET_FILTER_MODAL_OPEN = 'SET_FILTER_MODAL_OPEN'
export const FETCH_FILTER_OPTIONS_REQUEST = 'FETCH_FILTER_OPTIONS_REQUEST'
export const FETCH_FILTER_OPTIONS_SUCCESS = 'FETCH_FILTER_OPTIONS_SUCCESS'
export const FETCH_FILTER_OPTIONS_FAILURE = 'FETCH_FILTER_OPTIONS_FAILURE'

// Save Search
export const SAVE_SEARCH_SUCCESS = 'SAVE_SEARCH_SUCCESS'
export const DELETE_SAVED_SEARCH_SUCCESS = 'DELETE_SAVED_SEARCH_SUCCESS'
export const FETCH_SAVED_SEARCHES_SUCCESS = 'FETCH_SAVED_SEARCHES_SUCCESS'

// Search Bookmarks
export const TOGGLE_SEARCH_BOOKMARK_SUCCESS = 'TOGGLE_SEARCH_BOOKMARK_SUCCESS'
export const FETCH_SEARCH_BOOKMARKS_SUCCESS = 'FETCH_SEARCH_BOOKMARKS_SUCCESS'
export const CHECK_SEARCH_BOOKMARKS_SUCCESS = 'CHECK_SEARCH_BOOKMARKS_SUCCESS'

// BO (Bulletin Officiel) ACTION TYPES
export const FETCH_LATEST_BO_REQUEST = 'FETCH_LATEST_BO_REQUEST'
export const FETCH_LATEST_BO_SUCCESS = 'FETCH_LATEST_BO_SUCCESS'
export const FETCH_LATEST_BO_FAILURE = 'FETCH_LATEST_BO_FAILURE'
export const FETCH_BO_BY_ID_REQUEST = 'FETCH_BO_BY_ID_REQUEST'
export const FETCH_BO_BY_ID_SUCCESS = 'FETCH_BO_BY_ID_SUCCESS'
export const FETCH_BO_BY_ID_FAILURE = 'FETCH_BO_BY_ID_FAILURE'
export const SEARCH_BO_REQUEST = 'SEARCH_BO_REQUEST'
export const SEARCH_BO_SUCCESS = 'SEARCH_BO_SUCCESS'
export const SEARCH_BO_FAILURE = 'SEARCH_BO_FAILURE'
export const GET_DATA_UPDATE_ANALYSIS_REQUEST = 'GET_DATA_UPDATE_ANALYSIS_REQUEST'
export const GET_DATA_UPDATE_ANALYSIS_SUCCESS = 'GET_DATA_UPDATE_ANALYSIS_SUCCESS'
export const GET_DATA_UPDATE_ANALYSIS_FAILURE = 'GET_DATA_UPDATE_ANALYSIS_FAILURE'
export const GET_DOCUMENT_DETAILS_REQUEST = 'GET_DOCUMENT_DETAILS_REQUEST'
export const GET_DOCUMENT_DETAILS_SUCCESS = 'GET_DOCUMENT_DETAILS_SUCCESS'
export const GET_DOCUMENT_DETAILS_FAILURE = 'GET_DOCUMENT_DETAILS_FAILURE'
export const RESET_BO_STATE = 'RESET_BO_STATE'

// CONVERSATION ACTION TYPES
export const UPDATE_CONVERSATION_TITLE = 'UPDATE_CONVERSATION_TITLE'
export const FETCH_CONVERSATIONS_REQUEST = 'FETCH_CONVERSATIONS_REQUEST'
export const FETCH_CONVERSATIONS_SUCCESS = 'FETCH_CONVERSATIONS_SUCCESS'
export const FETCH_CONVERSATIONS_FAILURE = 'FETCH_CONVERSATIONS_FAILURE'
export const FETCH_CONVERSATION_REQUEST = 'FETCH_CONVERSATION_REQUEST'
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS'
export const FETCH_CONVERSATION_FAILURE = 'FETCH_CONVERSATION_FAILURE'
export const CREATE_CONVERSATION_REQUEST = 'CREATE_CONVERSATION_REQUEST'
export const CREATE_CONVERSATION_SUCCESS = 'CREATE_CONVERSATION_SUCCESS'
export const CREATE_CONVERSATION_FAILURE = 'CREATE_CONVERSATION_FAILURE'
export const SEARCH_CONVERSATIONS_REQUEST = 'SEARCH_CONVERSATIONS_REQUEST'
export const SEARCH_CONVERSATIONS_SUCCESS = 'SEARCH_CONVERSATIONS_SUCCESS'
export const SEARCH_CONVERSATIONS_FAILURE = 'SEARCH_CONVERSATIONS_FAILURE'
export const RESET_CONVERSATION = 'RESET_CONVERSATION'
export const UPDATE_MESSAGE_LIKE = 'UPDATE_MESSAGE_LIKE'
export const UPDATE_MESSAGE_CONTENT = 'UPDATE_MESSAGE_CONTENT';

export const SET_CONVERSATION = 'SET_CONVERSATION'
export const DELETE_CONVERSATION = 'DELETE_CONVERSATION'
export const SHARE_CONVERSATION_SUCCESS = 'SHARE_CONVERSATION_SUCCESS'

export const FETCH_FILTERED_CONVERSATIONS_REQUEST = 'FETCH_FILTERED_CONVERSATIONS_REQUEST';
export const FETCH_FILTERED_CONVERSATIONS_SUCCESS = 'FETCH_FILTERED_CONVERSATIONS_SUCCESS';
export const FETCH_FILTERED_CONVERSATIONS_FAILURE = 'FETCH_FILTERED_CONVERSATIONS_FAILURE';

// MARKETING ACTION TYPES
export const MARKETING_SET_LOADING = 'MARKETING_SET_LOADING'
export const MARKETING_SET_ERROR = 'MARKETING_SET_ERROR'
export const MARKETING_SET_DASHBOARD = 'MARKETING_SET_DASHBOARD'
export const MARKETING_SET_CAMPAIGNS = 'MARKETING_SET_CAMPAIGNS'
export const MARKETING_SET_CURRENT_CAMPAIGN = 'MARKETING_SET_CURRENT_CAMPAIGN'
export const MARKETING_SET_TEMPLATES = 'MARKETING_SET_TEMPLATES'
export const MARKETING_SET_CURRENT_TEMPLATE = 'MARKETING_SET_CURRENT_TEMPLATE'
export const MARKETING_SET_CONTACTS = 'MARKETING_SET_CONTACTS'
export const MARKETING_SET_CURRENT_CONTACT = 'MARKETING_SET_CURRENT_CONTACT'
export const MARKETING_UPDATE_CONTACT_IN_LIST = 'MARKETING_UPDATE_CONTACT_IN_LIST'
export const MARKETING_SET_SEGMENTS = 'MARKETING_SET_SEGMENTS'
export const MARKETING_SET_SEQUENCES = 'MARKETING_SET_SEQUENCES'
export const MARKETING_SET_ALL_SEQUENCES = 'MARKETING_SET_ALL_SEQUENCES'
export const MARKETING_SET_AUTOMATIONS = 'MARKETING_SET_AUTOMATIONS'
export const MARKETING_SET_SCORING_RULES = 'MARKETING_SET_SCORING_RULES'
export const MARKETING_SET_WHATSAPP_LOGS = 'MARKETING_SET_WHATSAPP_LOGS'
export const MARKETING_SET_CAMPAIGN_STATS = 'MARKETING_SET_CAMPAIGN_STATS'
export const MARKETING_SET_CAMPAIGN_FUNNEL = 'MARKETING_SET_CAMPAIGN_FUNNEL'
export const MARKETING_SET_TIMELINE = 'MARKETING_SET_TIMELINE'
export const MARKETING_SET_IMPORTS = 'MARKETING_SET_IMPORTS'
export const MARKETING_SET_CAMPAIGN_SENDS = 'MARKETING_SET_CAMPAIGN_SENDS'
export const MARKETING_SET_ORGANIZATIONS = 'MARKETING_SET_ORGANIZATIONS'
export const MARKETING_SET_CURRENT_ORGANIZATION = 'MARKETING_SET_CURRENT_ORGANIZATION'
export const MARKETING_SET_ORG_TASKS = 'MARKETING_SET_ORG_TASKS'
export const MARKETING_SET_ORG_ACTIVITY = 'MARKETING_SET_ORG_ACTIVITY'
export const MARKETING_SET_PIPELINE = 'MARKETING_SET_PIPELINE'
export const MARKETING_SET_UPCOMING_TASKS = 'MARKETING_SET_UPCOMING_TASKS'

// GMAIL INBOX ACTION TYPES
export const INBOX_SET_LOADING = 'INBOX_SET_LOADING'
export const INBOX_SET_ERROR = 'INBOX_SET_ERROR'
export const INBOX_SET_THREADS = 'INBOX_SET_THREADS'
export const INBOX_SET_CURRENT_THREAD = 'INBOX_SET_CURRENT_THREAD'
export const INBOX_SET_MESSAGES = 'INBOX_SET_MESSAGES'
export const INBOX_SET_SIGNATURE = 'INBOX_SET_SIGNATURE'
export const INBOX_SET_STATS = 'INBOX_SET_STATS'
export const INBOX_SET_CONTACTS = 'INBOX_SET_CONTACTS'

// LINKEDIN OUTREACH ACTION TYPES
export const LI_SET_LOADING = 'LI_SET_LOADING'
export const LI_SET_ERROR = 'LI_SET_ERROR'
export const LI_SET_DASHBOARD = 'LI_SET_DASHBOARD'
export const LI_SET_DASHBOARD_TIMESERIES = 'LI_SET_DASHBOARD_TIMESERIES'
export const LI_SET_DASHBOARD_ACCOUNTS_HEALTH = 'LI_SET_DASHBOARD_ACCOUNTS_HEALTH'
export const LI_SET_DASHBOARD_CAMPAIGNS_SUMMARY = 'LI_SET_DASHBOARD_CAMPAIGNS_SUMMARY'
export const LI_SET_ACCOUNTS = 'LI_SET_ACCOUNTS'
export const LI_SET_CURRENT_ACCOUNT = 'LI_SET_CURRENT_ACCOUNT'
export const LI_SET_ICPS = 'LI_SET_ICPS'
export const LI_SET_CURRENT_ICP = 'LI_SET_CURRENT_ICP'
export const LI_SET_LEADS = 'LI_SET_LEADS'
export const LI_SET_CURRENT_LEAD = 'LI_SET_CURRENT_LEAD'
export const LI_SET_IMPORTS = 'LI_SET_IMPORTS'
export const LI_SET_CAMPAIGNS = 'LI_SET_CAMPAIGNS'
export const LI_SET_CURRENT_CAMPAIGN = 'LI_SET_CURRENT_CAMPAIGN'
export const LI_SET_CAMPAIGN_STATS = 'LI_SET_CAMPAIGN_STATS'
export const LI_SET_CAMPAIGN_LEADS = 'LI_SET_CAMPAIGN_LEADS'
export const LI_SET_STEPS = 'LI_SET_STEPS'
export const LI_SET_CONVERSATIONS = 'LI_SET_CONVERSATIONS'
export const LI_SET_CURRENT_CONVERSATION = 'LI_SET_CURRENT_CONVERSATION'
export const LI_SET_MESSAGES = 'LI_SET_MESSAGES'
export const LI_SET_QUEUE = 'LI_SET_QUEUE'
export const LI_SET_ACTION_LOG = 'LI_SET_ACTION_LOG'



// MESSAGE ACTION TYPES
export const SET_MESSAGES = 'SET_MESSAGES'
export const USER_SEND_MESSAGE = 'USER_SEND_MESSAGE'
export const SYSTEM_SEND_MESSAGE = 'SYSTEM_SEND_MESSAGE'

// CONVERSATION - SSE & Loading
export const SET_MESSAGE_LOADING = 'SET_MESSAGE_LOADING'
export const SET_STREAMING_MESSAGE_ID = 'SET_STREAMING_MESSAGE_ID'
export const UPDATE_MESSAGE_SOURCES = 'UPDATE_MESSAGE_SOURCES'
export const UPDATE_MESSAGE_TOOLS = 'UPDATE_MESSAGE_TOOLS'
export const ADD_TOOL_EXECUTION = 'ADD_TOOL_EXECUTION'
export const SET_MESSAGE_ERROR = 'SET_MESSAGE_ERROR'
export const SET_PENDING_FILES = 'SET_PENDING_FILES'
export const CLEAR_PENDING_FILES = 'CLEAR_PENDING_FILES'

// CONVERSATION - Agentic Pipeline
export const UPDATE_MESSAGE_NODE_EXECUTION = 'UPDATE_MESSAGE_NODE_EXECUTION'
export const UPDATE_MESSAGE_PLAN = 'UPDATE_MESSAGE_PLAN'
export const UPDATE_MESSAGE_STEP_EXECUTION = 'UPDATE_MESSAGE_STEP_EXECUTION'
export const UPDATE_MESSAGE_METADATA = 'UPDATE_MESSAGE_METADATA'
export const UPDATE_MESSAGE_ARTIFACTS = 'UPDATE_MESSAGE_ARTIFACTS'

// CONVERSATION - Document Processing
export const SET_DOCUMENT_PROCESSING_STATUS = 'SET_DOCUMENT_PROCESSING_STATUS'
export const CLEAR_DOCUMENT_PROCESSING_STATUS = 'CLEAR_DOCUMENT_PROCESSING_STATUS'

// NAVBAR ACTION TYPES
// Action Types
export const OPEN_NAVBAR = 'OPEN_NAVBAR'
export const SET_OPEN_NAVBAR = 'SET_OPEN_NAVBAR'


// CONTRACT
export const UPDATE_CONTRACT_TEMPLATE = 'UPDATE_CONTRACT_TEMPLATE';
export const SET_HIGHLIGHT_ERROR = 'SET_HIGHLIGHT_ERROR';
export const UPDATE_CONTRACT_CONTENT = 'UPDATE_CONTRACT_CONTENT';
export const SET_CONTRACT_LOADING = 'SET_CONTRACT_LOADING';
export const SET_CONTRACT_DATA = 'SET_CONTRACT_DATA';
export const SET_CONTRACT_ERROR = 'SET_CONTRACT_ERROR';
export const RESET_CONTRACT = 'RESET_CONTRACT';
// ///
export const FETCH_CONTRACT_REQUEST = 'FETCH_CONTRACT_REQUEST';
export const FETCH_CONTRACT_SUCCESS = 'FETCH_CONTRACT_SUCCESS';
export const FETCH_CONTRACT_FAILURE = 'FETCH_CONTRACT_FAILURE';
export const SAVE_CONTRACT_REQUEST = 'SAVE_CONTRACT_REQUEST';
export const SAVE_CONTRACT_SUCCESS = 'SAVE_CONTRACT_SUCCESS';
export const SAVE_CONTRACT_FAILURE = 'SAVE_CONTRACT_FAILURE';
export const FETCH_CONTRACT_HISTORY_REQUEST = 'FETCH_CONTRACT_HISTORY_REQUEST';
export const FETCH_CONTRACT_HISTORY_SUCCESS = 'FETCH_CONTRACT_HISTORY_SUCCESS';
export const FETCH_CONTRACT_HISTORY_FAILURE = 'FETCH_CONTRACT_HISTORY_FAILURE';
export const ADD_HISTORY_ENTRY = 'ADD_HISTORY_ENTRY';
export const RESTORE_CONTRACT_VERSION = 'RESTORE_CONTRACT_VERSION';

// Activity feed (unified history)
export const FETCH_CONTRACT_ACTIVITY_REQUEST = 'FETCH_CONTRACT_ACTIVITY_REQUEST';
export const FETCH_CONTRACT_ACTIVITY_SUCCESS = 'FETCH_CONTRACT_ACTIVITY_SUCCESS';
export const FETCH_CONTRACT_ACTIVITY_FAILURE = 'FETCH_CONTRACT_ACTIVITY_FAILURE';

export const SHARE_CONTRACT_REQUEST = 'SHARE_CONTRACT_REQUEST';
export const SHARE_CONTRACT_FAILURE = 'SHARE_CONTRACT_FAILURE';
export const SHARE_CONTRACT_SUCCESS = 'SHARE_CONTRACT_SUCCESS';
//
export const FETCH_CONTRACTS_REQUEST = 'FETCH_CONTRACTS_REQUEST';
export const FETCH_CONTRACTS_SUCCESS = 'FETCH_CONTRACTS_SUCCESS';
export const FETCH_CONTRACTS_FAILURE = 'FETCH_CONTRACTS_FAILURE';
export const FETCH_CONTRACTS_BY_TAB_REQUEST = 'FETCH_CONTRACTS_BY_TAB_REQUEST';
export const FETCH_CONTRACTS_BY_TAB_SUCCESS = 'FETCH_CONTRACTS_BY_TAB_SUCCESS';
export const FETCH_CONTRACTS_BY_TAB_FAILURE = 'FETCH_CONTRACTS_BY_TAB_FAILURE';
export const SET_TAB_TOTAL_COUNT = 'SET_TAB_TOTAL_COUNT';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_TAB_PAGE = 'SET_TAB_PAGE';
export const CREATE_CONTRACT_REQUEST = 'CREATE_CONTRACT_REQUEST';
export const CREATE_CONTRACT_SUCCESS = 'CREATE_CONTRACT_SUCCESS';
export const CREATE_CONTRACT_FAILURE = 'CREATE_CONTRACT_FAILURE';
export const SEARCH_CONTRACTS_REQUEST = 'SEARCH_CONTRACTS_REQUEST';
export const SEARCH_CONTRACTS_SUCCESS = 'SEARCH_CONTRACTS_SUCCESS';
export const SEARCH_CONTRACTS_FAILURE = 'SEARCH_CONTRACTS_FAILURE';
export const DELETE_CONTRACTS_REQUEST = 'DELETE_CONTRACTS_REQUEST';
export const DELETE_CONTRACTS_SUCCESS = 'DELETE_CONTRACTS_SUCCESS';
export const DELETE_CONTRACTS_FAILURE = 'DELETE_CONTRACTS_FAILURE';
////
export const CONTRACT_MESSAGE_CLEAR = 'CONTRACT_MESSAGE_CLEAR';
export const CONTRACT_MESSAGE_SET = 'CONTRACT_MESSAGE_SET';
export const CONTRACT_MESSAGE_ADD_USER = 'CONTRACT_MESSAGE_ADD_USER';
export const CONTRACT_MESSAGE_STREAM_UPDATE = 'CONTRACT_MESSAGE_STREAM_UPDATE';
export const CONTRACT_MESSAGE_STREAM_DONE = 'CONTRACT_MESSAGE_STREAM_DONE';
export const CONTRACT_MESSAGE_ERROR = 'CONTRACT_MESSAGE_ERROR';
//
export const CLEAR_CHAT_REQUEST = 'CLEAR_CHAT_REQUEST';
export const CLEAR_CHAT_SUCCESS = 'CLEAR_CHAT_SUCCESS';
export const CLEAR_CHAT_FAILURE = 'CLEAR_CHAT_FAILURE';

// Create contract conversation types
export const CREATE_CONTRACT_CONVERSATION_REQUEST = 'CREATE_CONTRACT_CONVERSATION_REQUEST';
export const CREATE_CONTRACT_CONVERSATION_SUCCESS = 'CREATE_CONTRACT_CONVERSATION_SUCCESS';
export const CREATE_CONTRACT_CONVERSATION_FAILURE = 'CREATE_CONTRACT_CONVERSATION_FAILURE';

// Contract Chat - Rich execution tracking
export const CONTRACT_CHAT_UPDATE_MESSAGE = 'CONTRACT_CHAT_UPDATE_MESSAGE';
export const CONTRACT_CHAT_UPDATE_TOOLS = 'CONTRACT_CHAT_UPDATE_TOOLS';
export const CONTRACT_CHAT_ADD_TOOL_EXECUTION = 'CONTRACT_CHAT_ADD_TOOL_EXECUTION';
export const CONTRACT_CHAT_UPDATE_NODE_EXECUTION = 'CONTRACT_CHAT_UPDATE_NODE_EXECUTION';
export const CONTRACT_CHAT_UPDATE_PLAN = 'CONTRACT_CHAT_UPDATE_PLAN';
export const CONTRACT_CHAT_UPDATE_STEP_EXECUTION = 'CONTRACT_CHAT_UPDATE_STEP_EXECUTION';
export const CONTRACT_CHAT_UPDATE_SOURCES = 'CONTRACT_CHAT_UPDATE_SOURCES';
export const CONTRACT_CHAT_UPDATE_METADATA = 'CONTRACT_CHAT_UPDATE_METADATA';
export const CONTRACT_CHAT_UPDATE_EDITS = 'CONTRACT_CHAT_UPDATE_EDITS';
export const CONTRACT_CHAT_UPDATE_EDIT_STATUS = 'CONTRACT_CHAT_UPDATE_EDIT_STATUS';
export const CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTIONS = 'CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTIONS';
export const CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTION_STATUS = 'CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTION_STATUS';
export const CONTRACT_CHAT_UPDATE_REVIEW_PROGRESS = 'CONTRACT_CHAT_UPDATE_REVIEW_PROGRESS';

//
export const RISK_ANALYSIS_REQUEST = 'RISK_ANALYSIS_REQUEST';
export const RISK_ANALYSIS_RESET = 'RISK_ANALYSIS_RESET';
export const RISK_ANALYSIS_ADD = 'RISK_ANALYSIS_ADD';
export const RISK_ANALYSIS_ERROR = 'RISK_ANALYSIS_ERROR';
export const RISK_ANALYSIS_COMPLETE = 'RISK_ANALYSIS_COMPLETE';

// Key Info
export const KEY_INFO_REQUEST = 'KEY_INFO_REQUEST';
export const KEY_INFO_FETCH_SUCCESS = 'KEY_INFO_FETCH_SUCCESS';
export const KEY_INFO_EXTRACT_REQUEST = 'KEY_INFO_EXTRACT_REQUEST';
export const KEY_INFO_EXTRACT_UPDATE = 'KEY_INFO_EXTRACT_UPDATE';
export const KEY_INFO_EXTRACT_COMPLETE = 'KEY_INFO_EXTRACT_COMPLETE';
export const KEY_INFO_ERROR = 'KEY_INFO_ERROR';
export const KEY_INFO_UPDATE_FIELD = 'KEY_INFO_UPDATE_FIELD';
export const KEY_INFO_RESET = 'KEY_INFO_RESET';

// Law Dependencies
export const LAW_DEPS_REQUEST = 'LAW_DEPS_REQUEST';
export const LAW_DEPS_SUCCESS = 'LAW_DEPS_SUCCESS';
export const LAW_DEPS_ERROR = 'LAW_DEPS_ERROR';

// Regulatory Alerts
export const REG_ALERTS_REQUEST = 'REG_ALERTS_REQUEST';
export const REG_ALERTS_SUCCESS = 'REG_ALERTS_SUCCESS';
export const REG_ALERTS_ERROR = 'REG_ALERTS_ERROR';
export const REG_ALERT_UPDATE = 'REG_ALERT_UPDATE';

export const SET_CURRENT_CONVERSATION_ID = 'SET_CURRENT_CONVERSATION_ID';
//
export const UPDATE_CONTRACT_STATUS = 'UPDATE_CONTRACT_STATUS';
export const UPDATE_CONTRACT_STATUS_SUCCESS = 'UPDATE_CONTRACT_STATUS_SUCCESS';
export const UPDATE_CONTRACT_STATUS_FAILURE = 'UPDATE_CONTRACT_STATUS_FAILURE';
export const UPDATE_CONTRACT_COUNTRY_SUCCESS = 'UPDATE_CONTRACT_COUNTRY_SUCCESS';
export const REORDER_KANBAN_CONTRACTS = 'REORDER_KANBAN_CONTRACTS';

//
export const SIGNATURE_REQUEST_LOADING = 'SIGNATURE_REQUEST_LOADING';
export const SIGNATURE_REQUEST_SUCCESS = 'SIGNATURE_REQUEST_SUCCESS';
export const SIGNATURE_REQUEST_FAILURE = 'SIGNATURE_REQUEST_FAILURE';
// Signature list fetching
export const SIGNATURE_LIST_LOADING = 'SIGNATURE_LIST_LOADING';
export const SIGNATURE_LIST_SUCCESS = 'SIGNATURE_LIST_SUCCESS';
export const SIGNATURE_LIST_FAILURE = 'SIGNATURE_LIST_FAILURE';
// Signature cancellation
export const SIGNATURE_CANCEL_LOADING = 'SIGNATURE_CANCEL_LOADING';
export const SIGNATURE_CANCEL_SUCCESS = 'SIGNATURE_CANCEL_SUCCESS';
export const SIGNATURE_CANCEL_FAILURE = 'SIGNATURE_CANCEL_FAILURE';
// Signature reminder
export const SIGNATURE_REMIND_LOADING = 'SIGNATURE_REMIND_LOADING';
export const SIGNATURE_REMIND_SUCCESS = 'SIGNATURE_REMIND_SUCCESS';
export const SIGNATURE_REMIND_FAILURE = 'SIGNATURE_REMIND_FAILURE';
// Add
export const SIGNATURE_ADD_LOADING = 'SIGNATURE_ADD_LOADING';
export const SIGNATURE_ADD_SUCCESS = 'SIGNATURE_ADD_SUCCESS';
export const SIGNATURE_ADD_FAILURE = 'SIGNATURE_ADD_FAILURE';
// Delete
export const SIGNATURE_DELETE_LOADING = 'SIGNATURE_DELETE_LOADING'
export const SIGNATURE_DELETE_SUCCESS = 'SIGNATURE_DELETE_SUCCESS'
export const SIGNATURE_DELETE_FAILURE = 'SIGNATURE_DELETE_FAILURE'
// My pending signatures (documents to sign)
export const MY_PENDING_SIGNATURES_LOADING = 'MY_PENDING_SIGNATURES_LOADING';
export const MY_PENDING_SIGNATURES_SUCCESS = 'MY_PENDING_SIGNATURES_SUCCESS';
export const MY_PENDING_SIGNATURES_FAILURE = 'MY_PENDING_SIGNATURES_FAILURE';
export const MY_PENDING_SIGNATURES_COUNT = 'MY_PENDING_SIGNATURES_COUNT';
// Internal signing
export const INTERNAL_SIGN_LOADING = 'INTERNAL_SIGN_LOADING';
export const INTERNAL_SIGN_SUCCESS = 'INTERNAL_SIGN_SUCCESS';
export const INTERNAL_SIGN_FAILURE = 'INTERNAL_SIGN_FAILURE';
// Clauses
export const CLAUSES_REQUEST = 'CLAUSES_REQUEST';
export const CLAUSES_RESET = 'CLAUSES_RESET';
export const CLAUSES_ADD = 'CLAUSES_ADD';
export const CLAUSES_ERROR = 'CLAUSES_ERROR';
export const CLAUSES_COMPLETE = 'CLAUSES_COMPLETE';

// Contract Categories
export const FETCH_CONTRACT_CATEGORIES_REQUEST = 'FETCH_CONTRACT_CATEGORIES_REQUEST';
export const FETCH_CONTRACT_CATEGORIES_SUCCESS = 'FETCH_CONTRACT_CATEGORIES_SUCCESS';
export const FETCH_CONTRACT_CATEGORIES_FAILURE = 'FETCH_CONTRACT_CATEGORIES_FAILURE';
// Suggested Clauses
export const SUGGESTED_CLAUSES_REQUEST = 'SUGGESTED_CLAUSES_REQUEST';
export const SUGGESTED_CLAUSES_RESET = 'SUGGESTED_CLAUSES_RESET';
export const SUGGESTED_CLAUSES_ADD = 'SUGGESTED_CLAUSES_ADD';
export const SUGGESTED_CLAUSES_ERROR = 'SUGGESTED_CLAUSES_ERROR';
export const SUGGESTED_CLAUSES_COMPLETE = 'SUGGESTED_CLAUSES_COMPLETE';
// Filter
export const FILTER_CONTRACTS_REQUEST = 'FILTER_CONTRACTS_REQUEST';
export const FILTER_CONTRACTS_SUCCESS = 'FILTER_CONTRACTS_SUCCESS';
export const FILTER_CONTRACTS_FAILURE = 'FILTER_CONTRACTS_FAILURE';
//
export const UPDATE_CONTRACT_OPTIMISTIC = 'UPDATE_CONTRACT_OPTIMISTIC';

// Profile
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS'

// OTP ACTION TYPES
export const REQUEST_OTP = 'REQUEST_OTP'
export const REQUEST_OTP_SUCCESS = 'REQUEST_OTP_SUCCESS'
export const REQUEST_OTP_FAILURE = 'REQUEST_OTP_FAILURE'
export const VERIFY_OTP = 'VERIFY_OTP'
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS'
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE'
export const RESEND_OTP = 'RESEND_OTP'
export const RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS'
export const RESEND_OTP_FAILURE = 'RESEND_OTP_FAILURE'

// Action Types
export const FETCH_DEVICES_REQUEST = 'FETCH_DEVICES_REQUEST';
export const FETCH_DEVICES_SUCCESS = 'FETCH_DEVICES_SUCCESS';
export const FETCH_DEVICES_FAILURE = 'FETCH_DEVICES_FAILURE';
export const REMOVE_DEVICE_REQUEST = 'REMOVE_DEVICE_REQUEST';
export const REMOVE_DEVICE_SUCCESS = 'REMOVE_DEVICE_SUCCESS';
export const REMOVE_DEVICE_FAILURE = 'REMOVE_DEVICE_FAILURE';
export const RENAME_DEVICE_REQUEST = 'RENAME_DEVICE_REQUEST';
export const RENAME_DEVICE_SUCCESS = 'RENAME_DEVICE_SUCCESS';
export const RENAME_DEVICE_FAILURE = 'RENAME_DEVICE_FAILURE';
export const CLEAR_DEVICE_ERROR = 'CLEAR_DEVICE_ERROR';

// News
// types.js - Add these to your existing types file

// News fetching
export const FETCH_NEWS_REQUEST = "FETCH_NEWS_REQUEST";
export const FETCH_NEWS_SUCCESS = "FETCH_NEWS_SUCCESS";
export const FETCH_NEWS_FAILURE = "FETCH_NEWS_FAILURE";

// News item fetching
export const FETCH_NEWS_ITEM_REQUEST = "FETCH_NEWS_ITEM_REQUEST";
export const FETCH_NEWS_ITEM_SUCCESS = "FETCH_NEWS_ITEM_SUCCESS";
export const FETCH_NEWS_ITEM_FAILURE = "FETCH_NEWS_ITEM_FAILURE";

// Categories fetching
export const FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";

// Bookmarks fetching
export const FETCH_BOOKMARKS_REQUEST = "FETCH_BOOKMARKS_REQUEST";
export const FETCH_BOOKMARKS_SUCCESS = "FETCH_BOOKMARKS_SUCCESS";
export const FETCH_BOOKMARKS_FAILURE = "FETCH_BOOKMARKS_FAILURE";

// Add bookmark
export const ADD_BOOKMARK_REQUEST = "ADD_BOOKMARK_REQUEST";
export const ADD_BOOKMARK_SUCCESS = "ADD_BOOKMARK_SUCCESS";
export const ADD_BOOKMARK_FAILURE = "ADD_BOOKMARK_FAILURE";

// Remove bookmark
export const REMOVE_BOOKMARK_REQUEST = "REMOVE_BOOKMARK_REQUEST";
export const REMOVE_BOOKMARK_SUCCESS = "REMOVE_BOOKMARK_SUCCESS";
export const REMOVE_BOOKMARK_FAILURE = "REMOVE_BOOKMARK_FAILURE";

// News preferences
export const FETCH_PREFERENCES_REQUEST = "FETCH_PREFERENCES_REQUEST";
export const FETCH_PREFERENCES_SUCCESS = "FETCH_PREFERENCES_SUCCESS";
export const FETCH_PREFERENCES_FAILURE = "FETCH_PREFERENCES_FAILURE";

// Update preferences
export const UPDATE_PREFERENCES_REQUEST = "UPDATE_PREFERENCES_REQUEST";
export const UPDATE_PREFERENCES_SUCCESS = "UPDATE_PREFERENCES_SUCCESS";
export const UPDATE_PREFERENCES_FAILURE = "UPDATE_PREFERENCES_FAILURE";

// Recommendations fetching
export const FETCH_RECOMMENDATIONS_REQUEST = "FETCH_RECOMMENDATIONS_REQUEST";
export const FETCH_RECOMMENDATIONS_SUCCESS = "FETCH_RECOMMENDATIONS_SUCCESS";
export const FETCH_RECOMMENDATIONS_FAILURE = "FETCH_RECOMMENDATIONS_FAILURE";

// UI state
export const SET_CURRENT_CATEGORY = "SET_CURRENT_CATEGORY";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";

// News country/region filters
export const FETCH_NEWS_COUNTRIES_REQUEST = "FETCH_NEWS_COUNTRIES_REQUEST";
export const FETCH_NEWS_COUNTRIES_SUCCESS = "FETCH_NEWS_COUNTRIES_SUCCESS";
export const FETCH_NEWS_COUNTRIES_FAILURE = "FETCH_NEWS_COUNTRIES_FAILURE";
export const FETCH_NEWS_REGIONS_REQUEST = "FETCH_NEWS_REGIONS_REQUEST";
export const FETCH_NEWS_REGIONS_SUCCESS = "FETCH_NEWS_REGIONS_SUCCESS";
export const FETCH_NEWS_REGIONS_FAILURE = "FETCH_NEWS_REGIONS_FAILURE";
export const SET_SELECTED_COUNTRIES = "SET_SELECTED_COUNTRIES";
export const SET_SELECTED_REGION = "SET_SELECTED_REGION";
export const SET_DETECTED_COUNTRY = "SET_DETECTED_COUNTRY";

// App preferences
export const FETCH_APP_PREFERENCES_REQUEST = 'FETCH_APP_PREFERENCES_REQUEST';
export const FETCH_APP_PREFERENCES_SUCCESS = 'FETCH_APP_PREFERENCES_SUCCESS';
export const FETCH_APP_PREFERENCES_FAILURE = 'FETCH_APP_PREFERENCES_FAILURE';
export const UPDATE_APP_PREFERENCES_REQUEST = 'UPDATE_APP_PREFERENCES_REQUEST';
export const UPDATE_APP_PREFERENCES_SUCCESS = 'UPDATE_APP_PREFERENCES_SUCCESS';
export const UPDATE_APP_PREFERENCES_FAILURE = 'UPDATE_APP_PREFERENCES_FAILURE';

// Country preference action types
export const UPDATE_COUNTRY_PREFERENCE = 'UPDATE_COUNTRY_PREFERENCE';

// Jurisdiction preference action types
export const UPDATE_JURISDICTION_PREFERENCE = 'UPDATE_JURISDICTION_PREFERENCE';
export const SET_JURISDICTION_TREE = 'SET_JURISDICTION_TREE';

// Chat preferences (local to chat screen)
export const SET_SEARCH_MODE = 'SET_SEARCH_MODE'

// Language preferences action types
export const FETCH_LANGUAGE_PREFERENCES_REQUEST = 'FETCH_LANGUAGE_PREFERENCES_REQUEST';
export const FETCH_LANGUAGE_PREFERENCES_SUCCESS = 'FETCH_LANGUAGE_PREFERENCES_SUCCESS';
export const FETCH_LANGUAGE_PREFERENCES_FAILURE = 'FETCH_LANGUAGE_PREFERENCES_FAILURE';
export const UPDATE_LANGUAGE_PREFERENCES_REQUEST = 'UPDATE_LANGUAGE_PREFERENCES_REQUEST';
export const UPDATE_LANGUAGE_PREFERENCES_SUCCESS = 'UPDATE_LANGUAGE_PREFERENCES_SUCCESS';
export const UPDATE_LANGUAGE_PREFERENCES_FAILURE = 'UPDATE_LANGUAGE_PREFERENCES_FAILURE';

// ENTREPRISES (Annonces Legales)
export const ENTREPRISES_SEARCH_REQUEST = 'ENTREPRISES_SEARCH_REQUEST'
export const ENTREPRISES_SEARCH_SUCCESS = 'ENTREPRISES_SEARCH_SUCCESS'
export const ENTREPRISES_SEARCH_FAILURE = 'ENTREPRISES_SEARCH_FAILURE'
export const ENTREPRISES_FETCH_DETAIL_REQUEST = 'ENTREPRISES_FETCH_DETAIL_REQUEST'
export const ENTREPRISES_FETCH_DETAIL_SUCCESS = 'ENTREPRISES_FETCH_DETAIL_SUCCESS'
export const ENTREPRISES_FETCH_DETAIL_FAILURE = 'ENTREPRISES_FETCH_DETAIL_FAILURE'
export const ENTREPRISES_FETCH_COMPANY_REQUEST = 'ENTREPRISES_FETCH_COMPANY_REQUEST'
export const ENTREPRISES_FETCH_COMPANY_SUCCESS = 'ENTREPRISES_FETCH_COMPANY_SUCCESS'
export const ENTREPRISES_FETCH_COMPANY_FAILURE = 'ENTREPRISES_FETCH_COMPANY_FAILURE'
export const ENTREPRISES_FETCH_STATS_REQUEST = 'ENTREPRISES_FETCH_STATS_REQUEST'
export const ENTREPRISES_FETCH_STATS_SUCCESS = 'ENTREPRISES_FETCH_STATS_SUCCESS'
export const ENTREPRISES_FETCH_STATS_FAILURE = 'ENTREPRISES_FETCH_STATS_FAILURE'
export const ENTREPRISES_AUTOCOMPLETE_REQUEST = 'ENTREPRISES_AUTOCOMPLETE_REQUEST'
export const ENTREPRISES_AUTOCOMPLETE_SUCCESS = 'ENTREPRISES_AUTOCOMPLETE_SUCCESS'
export const ENTREPRISES_AUTOCOMPLETE_FAILURE = 'ENTREPRISES_AUTOCOMPLETE_FAILURE'
export const ENTREPRISES_SET_FILTERS = 'ENTREPRISES_SET_FILTERS'
export const ENTREPRISES_CLEAR_FILTERS = 'ENTREPRISES_CLEAR_FILTERS'
export const ENTREPRISES_SET_QUERY = 'ENTREPRISES_SET_QUERY'
export const ENTREPRISES_SET_PAGE = 'ENTREPRISES_SET_PAGE'
export const ENTREPRISES_RESET = 'ENTREPRISES_RESET'

// DATA UPDATE
export const DATA_UPDATE_SET_COUNTRY = 'DATA_UPDATE_SET_COUNTRY'
export const DATA_UPDATE_SET_DOC_TYPE = 'DATA_UPDATE_SET_DOC_TYPE'
export const DATA_UPDATE_REFERENCE_DATA_REQUEST = 'DATA_UPDATE_REFERENCE_DATA_REQUEST'
export const DATA_UPDATE_REFERENCE_DATA_SUCCESS = 'DATA_UPDATE_REFERENCE_DATA_SUCCESS'
export const DATA_UPDATE_REFERENCE_DATA_FAILURE = 'DATA_UPDATE_REFERENCE_DATA_FAILURE'
export const DATA_UPDATE_UPLOAD_START = 'DATA_UPDATE_UPLOAD_START'
export const DATA_UPDATE_UPLOAD_PROGRESS = 'DATA_UPDATE_UPLOAD_PROGRESS'
export const DATA_UPDATE_REVIEW_READY = 'DATA_UPDATE_REVIEW_READY'
export const DATA_UPDATE_UPLOAD_ERROR = 'DATA_UPDATE_UPLOAD_ERROR'
export const DATA_UPDATE_PUBLISH_START = 'DATA_UPDATE_PUBLISH_START'
export const DATA_UPDATE_PUBLISH_PROGRESS = 'DATA_UPDATE_PUBLISH_PROGRESS'
export const DATA_UPDATE_PUBLISH_COMPLETE = 'DATA_UPDATE_PUBLISH_COMPLETE'
export const DATA_UPDATE_PUBLISH_ERROR = 'DATA_UPDATE_PUBLISH_ERROR'
export const DATA_UPDATE_SEARCH_REQUEST = 'DATA_UPDATE_SEARCH_REQUEST'
export const DATA_UPDATE_SEARCH_SUCCESS = 'DATA_UPDATE_SEARCH_SUCCESS'
export const DATA_UPDATE_SEARCH_FAILURE = 'DATA_UPDATE_SEARCH_FAILURE'
export const DATA_UPDATE_SELECT_DOC_REQUEST = 'DATA_UPDATE_SELECT_DOC_REQUEST'
export const DATA_UPDATE_SELECT_DOC_SUCCESS = 'DATA_UPDATE_SELECT_DOC_SUCCESS'
export const DATA_UPDATE_SELECT_DOC_FAILURE = 'DATA_UPDATE_SELECT_DOC_FAILURE'
export const DATA_UPDATE_ABROGATE_REQUEST = 'DATA_UPDATE_ABROGATE_REQUEST'
export const DATA_UPDATE_ABROGATE_SUCCESS = 'DATA_UPDATE_ABROGATE_SUCCESS'
export const DATA_UPDATE_ABROGATE_FAILURE = 'DATA_UPDATE_ABROGATE_FAILURE'
export const DATA_UPDATE_EDIT_SAVE_REQUEST = 'DATA_UPDATE_EDIT_SAVE_REQUEST'
export const DATA_UPDATE_EDIT_SAVE_SUCCESS = 'DATA_UPDATE_EDIT_SAVE_SUCCESS'
export const DATA_UPDATE_EDIT_SAVE_FAILURE = 'DATA_UPDATE_EDIT_SAVE_FAILURE'
export const DATA_UPDATE_RESET_ADD_FLOW = 'DATA_UPDATE_RESET_ADD_FLOW'
export const DATA_UPDATE_RESET_EDIT_FLOW = 'DATA_UPDATE_RESET_EDIT_FLOW'
export const DATA_UPDATE_RESET_ABROGATE_FLOW = 'DATA_UPDATE_RESET_ABROGATE_FLOW'
// BO Consolidation
export const BO_CONSOL_FETCH_LIST_REQUEST = 'BO_CONSOL_FETCH_LIST_REQUEST'
export const BO_CONSOL_FETCH_LIST_SUCCESS = 'BO_CONSOL_FETCH_LIST_SUCCESS'
export const BO_CONSOL_FETCH_LIST_FAILURE = 'BO_CONSOL_FETCH_LIST_FAILURE'
export const BO_CONSOL_SELECT_BO = 'BO_CONSOL_SELECT_BO'
export const BO_CONSOL_SET_PHASE = 'BO_CONSOL_SET_PHASE'
export const BO_CONSOL_CLEAN_START = 'BO_CONSOL_CLEAN_START'
export const BO_CONSOL_CLEAN_PROGRESS = 'BO_CONSOL_CLEAN_PROGRESS'
export const BO_CONSOL_CLEAN_COMPLETE = 'BO_CONSOL_CLEAN_COMPLETE'
export const BO_CONSOL_CLEAN_ERROR = 'BO_CONSOL_CLEAN_ERROR'
export const BO_CONSOL_FETCH_EXTRACTED_REQUEST = 'BO_CONSOL_FETCH_EXTRACTED_REQUEST'
export const BO_CONSOL_FETCH_EXTRACTED_SUCCESS = 'BO_CONSOL_FETCH_EXTRACTED_SUCCESS'
export const BO_CONSOL_FETCH_EXTRACTED_FAILURE = 'BO_CONSOL_FETCH_EXTRACTED_FAILURE'
export const BO_CONSOL_UPDATE_DOC_STATUS = 'BO_CONSOL_UPDATE_DOC_STATUS'
export const BO_CONSOL_EXECUTE_START = 'BO_CONSOL_EXECUTE_START'
export const BO_CONSOL_EXECUTE_PROGRESS = 'BO_CONSOL_EXECUTE_PROGRESS'
export const BO_CONSOL_EXECUTE_COMPLETE = 'BO_CONSOL_EXECUTE_COMPLETE'
export const BO_CONSOL_EXECUTE_ERROR = 'BO_CONSOL_EXECUTE_ERROR'
export const BO_CONSOL_RESET = 'BO_CONSOL_RESET'
export const BO_CONSOL_SET_LIST_PAGE = 'BO_CONSOL_SET_LIST_PAGE'
export const BO_CONSOL_SET_LIST_FILTER = 'BO_CONSOL_SET_LIST_FILTER'
export const BO_CONSOL_SET_LIST_SEARCH = 'BO_CONSOL_SET_LIST_SEARCH'
export const BO_CONSOL_SET_LIST_LANGUAGE = 'BO_CONSOL_SET_LIST_LANGUAGE'
export const BO_CONSOL_SET_LIST_DATE_RANGE = 'BO_CONSOL_SET_LIST_DATE_RANGE'
export const BO_CONSOL_SYNC_START = 'BO_CONSOL_SYNC_START'
export const BO_CONSOL_SYNC_COMPLETE = 'BO_CONSOL_SYNC_COMPLETE'
export const BO_CONSOL_SYNC_ERROR = 'BO_CONSOL_SYNC_ERROR'
// Consolidation preview
export const BO_CONSOL_PREVIEW_BULK_START = 'BO_CONSOL_PREVIEW_BULK_START'
export const BO_CONSOL_PREVIEW_BULK_PROGRESS = 'BO_CONSOL_PREVIEW_BULK_PROGRESS'
export const BO_CONSOL_PREVIEW_BULK_COMPLETE = 'BO_CONSOL_PREVIEW_BULK_COMPLETE'
export const BO_CONSOL_PREVIEW_BULK_ERROR = 'BO_CONSOL_PREVIEW_BULK_ERROR'
export const BO_CONSOL_PREVIEW_SINGLE_START = 'BO_CONSOL_PREVIEW_SINGLE_START'
export const BO_CONSOL_PREVIEW_SINGLE_COMPLETE = 'BO_CONSOL_PREVIEW_SINGLE_COMPLETE'
export const BO_CONSOL_PREVIEW_SINGLE_ERROR = 'BO_CONSOL_PREVIEW_SINGLE_ERROR'
export const BO_CONSOL_FETCH_PREVIEW_REQUEST = 'BO_CONSOL_FETCH_PREVIEW_REQUEST'
export const BO_CONSOL_FETCH_PREVIEW_SUCCESS = 'BO_CONSOL_FETCH_PREVIEW_SUCCESS'
export const BO_CONSOL_FETCH_PREVIEW_FAILURE = 'BO_CONSOL_FETCH_PREVIEW_FAILURE'
export const BO_CONSOL_CONFIRM_PREVIEW_SUCCESS = 'BO_CONSOL_CONFIRM_PREVIEW_SUCCESS'
export const BO_CONSOL_OPEN_PREVIEW = 'BO_CONSOL_OPEN_PREVIEW'
export const BO_CONSOL_CLOSE_PREVIEW = 'BO_CONSOL_CLOSE_PREVIEW'

// Workspaces & Folders
export const WORKSPACES_REQUEST = 'WORKSPACES_REQUEST';
export const WORKSPACES_SUCCESS = 'WORKSPACES_SUCCESS';
export const WORKSPACES_FAILURE = 'WORKSPACES_FAILURE';
export const FOLDERS_REQUEST = 'FOLDERS_REQUEST';
export const FOLDERS_SUCCESS = 'FOLDERS_SUCCESS';
export const FOLDERS_FAILURE = 'FOLDERS_FAILURE';
export const SMART_VIEWS_REQUEST = 'SMART_VIEWS_REQUEST';
export const SMART_VIEWS_SUCCESS = 'SMART_VIEWS_SUCCESS';
export const SMART_VIEWS_FAILURE = 'SMART_VIEWS_FAILURE';
export const SET_ACTIVE_WORKSPACE = 'SET_ACTIVE_WORKSPACE';
export const SET_ACTIVE_FOLDER = 'SET_ACTIVE_FOLDER';
export const SET_ACTIVE_SMART_VIEW = 'SET_ACTIVE_SMART_VIEW';
export const CREATE_WORKSPACE_SUCCESS = 'CREATE_WORKSPACE_SUCCESS';
export const CREATE_FOLDER_SUCCESS = 'CREATE_FOLDER_SUCCESS';
export const CREATE_SMART_VIEW_SUCCESS = 'CREATE_SMART_VIEW_SUCCESS';
export const DELETE_SMART_VIEW_SUCCESS = 'DELETE_SMART_VIEW_SUCCESS';
export const SMART_VIEW_COUNTS_SUCCESS = 'SMART_VIEW_COUNTS_SUCCESS';

// MONITORING
export const SET_ACTIVE_MONITORING_VIEW = 'SET_ACTIVE_MONITORING_VIEW';
export const FETCH_MONITORING_ALERTS_REQUEST = 'FETCH_MONITORING_ALERTS_REQUEST';
export const FETCH_MONITORING_ALERTS_SUCCESS = 'FETCH_MONITORING_ALERTS_SUCCESS';
export const FETCH_MONITORING_ALERTS_FAILURE = 'FETCH_MONITORING_ALERTS_FAILURE';
export const FETCH_MONITORING_LIFECYCLE_REQUEST = 'FETCH_MONITORING_LIFECYCLE_REQUEST';
export const FETCH_MONITORING_LIFECYCLE_SUCCESS = 'FETCH_MONITORING_LIFECYCLE_SUCCESS';
export const FETCH_MONITORING_LIFECYCLE_FAILURE = 'FETCH_MONITORING_LIFECYCLE_FAILURE';

// FACTURATION (DEVIS) ACTION TYPES
export const FACTURATION_SET_LOADING = 'FACTURATION_SET_LOADING'
export const FACTURATION_SET_ERROR = 'FACTURATION_SET_ERROR'
export const FACTURATION_SET_QUOTES = 'FACTURATION_SET_QUOTES'
export const FACTURATION_SET_CURRENT_QUOTE = 'FACTURATION_SET_CURRENT_QUOTE'
export const FACTURATION_SET_MARKETING_ORGS = 'FACTURATION_SET_MARKETING_ORGS'
export const FACTURATION_SET_CURRENT_MARKETING_ORG = 'FACTURATION_SET_CURRENT_MARKETING_ORG'
export const FACTURATION_UPDATE_QUOTE_IN_LIST = 'FACTURATION_UPDATE_QUOTE_IN_LIST'
export const FACTURATION_REMOVE_QUOTE_FROM_LIST = 'FACTURATION_REMOVE_QUOTE_FROM_LIST'
